import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';

/**
 * Visual affordance shown next to any button or link label that hands off to
 * a real browser tab via the Discord SDK's `openExternalLink` (or the
 * `openInBrowser` helper that wraps it). Communicates "this leaves the
 * Activity iframe" before the click, so the feed-forward isn't ambiguous
 * with in-Activity buttons that stay inside the iframe (which intentionally
 * don't render this) — the cue means exactly one thing.
 *
 * Renders the same `arrow-up-right-from-square` glyph the web app uses for
 * popout links (DesktopSidebar, OrganizationGitHub, JobDetailsSidebar,
 * Plans/CurrentPlanBanner, …) so the convention is uniform across surfaces.
 *
 * Uses the tree-shaken FontAwesome SVG package — same pattern as
 * `TesterDeviceIcons` (#3968): the Activity iframe's strict outbound URL
 * allowlist makes the className-on-CDN-font path fragile, and shipping a
 * single ~1KB SVG is cheaper than the full FA stylesheet.
 *
 * `aria-hidden` so screen readers don't double-announce the icon — the
 * surrounding button label is the accessible name.
 */
export function ExternalLinkIcon() {
  return (
    <FontAwesomeIcon
      icon={faArrowUpRightFromSquare}
      className="external-link-icon"
      aria-hidden="true"
    />
  );
}
